<template>
  <div>
    <div class="content" style="padding-top: 20px; padding-bottom: 50px;">
      <div class="col">
        <div v-html="content"></div>
        <div v-if="showMap && useGoogleMaps">
          <gmaps-map :options="mapOptions">
            <gmaps-info-window
              :options="infoOptions"
              style="background:#fff;" v-html="mapsContent">
            </gmaps-info-window>
          </gmaps-map>
        </div>
      </div>
      <div class="col">
        <template v-for="element in form">
          <div v-if="element.type === 'subtitle'" :key="element.id">
            <div class="form-group row">
              <h2>{{ element.title }}</h2>
            </div>
          </div>

          <div v-if="element.type === 'title'" :key="element.id">
            <div class="form-group row">
              <h1>{{ element.title }}</h1>
            </div>
          </div>

          <div v-if="element.type === 'spacer'" :key="element.id">
            <div class="form-group row">
              &nbsp;&nbsp;
            </div>
          </div>

          <div v-if="element.type === 'text'" :key="element.id">
            <div class="form-group row">
              <label for="" class="col-sm-4 col-form-label">{{ element.title }}:</label>
              <div class="col-sm-8">
                <input type="text" :name="element.title" v-validate :required="element.required" v-model="element.value" class="form-control" :placeholder="element.title" />
                <span class="form-error">{{ errors[element.title] }}</span>
              </div>
            </div>
          </div>

          <div v-if="element.type === 'textarea'" :key="element.id">
            <div class="form-group form-vertical">
              <label :for="element.title">{{ element.title }}</label>
              <textarea :name="element.title" v-validate :id="element.title" :required="element.required" v-model="element.value" class="text-form"></textarea>
              <span class="form-error">{{ errors[element.title] }}</span>
            </div>
          </div>

          <div v-if="element.type === 'dropdown'" :key="element.id">
            <div class="form-group row">
              <label :for="element.title" class="col-sm-4 col-form-label">{{ element.title }}:</label>
              <div class="col-sm-8">
                <select :name="element.title" v-validate :required="element.required" :model="element.value" v-on:change="handleSelect(element, $event)" class="form-control">
                  <template v-for="option in element.options">
                    <option :value="option.value" :key="option.value">{{ option.value }}</option>
                  </template>
                </select>
                <span class="form-error">{{ errors[element.title] }}</span>
              </div>
            </div>
          </div>

          <div v-if="element.type === 'radio'" :key="element.id">
            <div class="form-group row">
              <div class="col-sm-12" style="text-align: right;">
                <label :for="element.title" class="form-label" style="display: block;">{{ element.title }}</label>
                <template v-for="option in element.options">
                  <div class="custom-control custom-radio custom-control-inline" :key="option.value">
                    <input type="radio" :id="option.value" :name="element.title" :value="option.value" :model="element.value" v-on:change="handleRadio(element, $event)" class="custom-control-input">
                    <label class="custom-control-label" :for="option.value">{{ option.value }}</label>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div v-if="element.type === 'date'" :key="element.id">
            <div class="form-group row">
              <label for="" class="col-sm-4 col-form-label">{{ element.title }}:</label>
              <div class="col-sm-8">
                <input type="date" :name="element.title" v-validate :required="element.required" v-model="element.value" class="form-control" placeholder="dd-mm-jjjj" />
                <span class="form-error">{{ errors[element.title] }}</span>
              </div>
            </div>
          </div>

          <div v-if="element.type === 'time'" :key="element.id">
            <div class="form-group row">
              <label for="" class="col-sm-4 col-form-label">{{ element.title }}:</label>
              <div class="col-sm-8">
                <input type="time" :name="element.title" v-validate :required="element.required" v-model="element.value" class="form-control" placeholder="dd-mm-jjjj" />
                <span class="form-error">{{ errors[element.title] }}</span>
              </div>
            </div>
          </div>

          <div v-if="element.type === 'email'" :key="element.id">
            <div class="form-group row">
              <label for="" class="col-sm-4 col-form-label">{{ element.title }}:</label>
              <div class="col-sm-8">
                <input type="email" :name="element.title" v-validate :required="element.required" v-model="element.value" class="form-control" :placeholder="element.title" />
                <span class="form-error">{{ errors[element.title] }}</span>
              </div>
            </div>
          </div>
        </template>

        <div class="form-group row" style="display: none;">
          <label for="" class="col-sm-4 col-form-label">AIS Data:</label>
          <div class="col-sm-8">
            <input type="hidden" name="AIS Data" style="display: none;" v-model="aisData" class="form-control" placeholder="AIS Data" />
          </div>
        </div>

        <div class="form-group">
          <div class="btn call-to-action-btn btn-zoom" v-on:click="sendForm" v-if="noFormSendYet && !hasErrors">
            {{ settings.send_button_text }}
          </div>
          <span class="form-error" v-if="hasErrors">{{ getErrorMessage }}</span>
          <div class="spinner-border" role="status" v-if="sendingForm">
            <font-awesome-icon :icon="spinner" class="fa-spin spinner"></font-awesome-icon>
          </div>
        </div>

        <div v-if="!sendingForm">
          <div class="alert alert-success" v-if="sendFormOk" v-html="settings.send_succes_message">
          </div>

          <div v-if="!noFormSendYet">
            <div class="alert alert-danger" v-if="!sendFormOk" v-html="settings.send_failed_message">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { useGoogleMaps } from '../../../_config/config'
import { gmapsMap, gmapsInfoWindow } from 'x5-gmaps'
import { ValidateMixin } from '../../../mixins/validate'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'

export default {
  name: 'Col3WithForms',
  mixins: [ValidateMixin],
  components: {
    gmapsMap,
    gmapsInfoWindow
  },
  data () {
    return {
      sendSuccess: false,
      sendFailed: false,
      sendMessage: 'Message',
      mapOptions: {
        center: { lat: parseFloat(this.mapsData.lat), lng: parseFloat(this.mapsData.lng) },
        zoom: parseInt(this.mapsData.zoom)
      },
      infoOptions: {
        position: { lat: parseFloat(this.mapsData.lat), lng: parseFloat(this.mapsData.lng) }
      },
      aisData: '' /* Used as a spam trap, it needs to stay empty, but a simple bot will fill it in */,
      spinner: faSpinner,
      useGoogleMaps: useGoogleMaps,
      mapsContent: this.mapsData.windowText + '<p><em><a target="_blank" href="' + this.mapsData.linktoGMaps + '">' + this.mapsData.textLinkToGMaps + '</a></em></p>'
    }
  },
  props: {
    content: {
      type: String,
      required: false,
      default: 'Content goes here '
    },
    form: {
      type: Array,
      required: false
    },
    settings: {
      type: Object,
      required: false
    },
    slug: {
      type: String,
      required: false,
      default: ''
    },
    langIso: {
      type: String,
      required: false,
      default: ''
    },
    showMap: {
      type: Boolean,
      required: false,
      default: false
    },
    mapsData: {
      type: Object,
      required: false
    }
  },
  watch: {
    sendFormOk: function (value) {
      if (value) {
        if (this.settings.send_success_url !== 'undefined') {
          // Redirect to thank you page
          window.location.href = this.settings.send_success_url
        }
      }
    }
  },
  computed: {
    ...mapGetters('form', [
      'sendingForm',
      'sendFormOk',
      'noFormSendYet'
    ]),
    getErrorMessage () {
      const lang = this.$route.params.lang

      if (lang === 'nl') {
        return 'Er staan fouten in dit formulier, scroll naar boven en corrigeer deze fouten'
      } else if (lang === 'de') {
        return 'Es gibt Fehler in diesem Formular, bitte scrollen Sie nach oben und korrigieren Sie diese Fehler'
      } else {
        return 'There are errors in this form, please scroll up and correct these errors'
      }
    }
  },
  mounted () {
    // Little workaround to make sure the first option is selected automatically.
    // for (var i = 0; i < this.form.length; i++) {
    //   if (this.form[i].type === 'dropdown') {
    //     this.initSelect(i, this.form[i].options[0].value)
    //   }
    // }
  },
  methods: {
    forceSelect (position, value) {
      this.form[position].value = value
    },
    handleSelect (element, event) {
      element.value = event.target.value
    },
    handleRadio (element, event) {
      element.value = event.target.value
    },
    sendForm () {
      for (var i = 0; i < this.form.length; i++) {
        if (this.form[i].type === 'dropdown' && typeof this.form[i].value === 'undefined') {
          this.forceSelect(i, this.form[i].options[0].value)
        }
      }

      this.validate()

      if (!this.hasErrors) {
        // Add the fake field to this form...
        this.form.push({
          id: '',
          type: 'hidden',
          title: 'AIS Data',
          value: this.aisData,
          required: false
        })

        this.$store.dispatch('form/send', {
          data: {
            slug: this.slug,
            path: this.$route.path,
            iso: this.langIso,
            fields: this.form
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.gmaps-map {
  height: 450px;
}

.space-holder {
  margin-bottom: 0px;
}

.content .col p {
  padding-left: 0px;
}

.form-error {
  color: red;
  font-style: italic;
  font-size: 12px;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}

textarea {
  background-color: #d0e3f3;
  border-top-left-radius: 20px;
  border: 0px;
  height: 120px;
  width: 100%;
  padding-left: 10px;
  padding-top: 10px;
}

.form-group {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-top: 15px;
  margin-bottom: 15px;
}

.form-group .btn {
  position: absolute;
  right: 20px;
}

.form-group .spinner {
  position: absolute;
  right: 10px;
  font-size: 20px;
}

.form-vertical {
  flex-direction: column;
}

.col-form-label {
  padding-top: calc(.375rem + 1px);
  padding-bottom: calc(.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .375rem .75rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
}

label {
  display: inline-block;
  /* margin-bottom: .5rem; */
}

.custom-control {
  position: relative;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

/* .custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.25rem;
  opacity: 0;
} */

input[type="radio"] {
    appearance: auto;
    height: auto;
    -webkit-appearance: radio;
    /* margin-block: 3px 0;
    margin-inline: 5px 3px; */
}

textarea {
  height: 120px;
  width: 100%;
  padding-top: 10px;
}

input {
  background-color: #d0e3f3;
  border-top-left-radius: 20px;
  border: 0px;
  height: 35px;
  padding-left: 10px;
  -webkit-appearance: none;
  /* flex-basis: 50%; */
}

select {
  padding: 5px;
  font-size: 15px;
  line-height: 1;
  border: 0;
  border-top-left-radius: 20px;
  height: 35px;
  background: url("/img/select.png") no-repeat right #d0e3f3;
  -webkit-appearance: none;
  background-position-x: right;
  padding-left: 10px;
}

.second-content {
  display: flex;
  width: 100%;
}

.second-content .col:nth-child(1) {
  flex-basis: 33%;
  margin: 0px 10px 0px 10px;
}

.second-content .col:nth-child(2) {
  flex-basis: 66%;
  margin: 0px 20px 0px 10px;
}

.alert {
  padding: 10px 20px;
}

.alert-success {
  background-color: #6ab04c;
  color: #fff;
}

.alert-danger {
  background-color: #eb4d4b;
  color: #fff;
}

.call-to-action-btn {
  font-size: 15px;
  background-color: #ce5e31;
  color: #fff;
  border-radius: 20px;
  width: auto;
  padding: 5px 20px;
}

ul {
  list-style: none;
  margin-left: 0px;
  padding-left: 0px;
  color: #ce5e31;
  display: table;
}

li {
  color: #000;
  font-size: 15px;
  display: table-row;
}

li:before {
  content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
  color: #ce5e31; /* Change the color */
  font-weight: bold; /* If you want it to be bold */
  display: inline-block; /* Needed to add space between the bullet and the text */
  padding-right: 8px;
  font-size:50px;
  vertical-align:top;
  line-height:20px;
  display: table-cell;
}

.content {
  position: relative;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.content .col {
  padding-bottom: 20px;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
  .content .col {
    flex-basis: calc(100%);
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .second-content .col:nth-child(1) {
    flex-basis: 0%;
  }

  .second-content .col:nth-child(2) {
    flex-basis: 100%;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  .content .col {
    flex-basis: calc(100%);
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .second-content .col:nth-child(1) {
    flex-basis: 0%;
  }

  .second-content .col:nth-child(2) {
    flex-basis: 100%;
  }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .content .col {
    flex-basis: calc(100%);
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .second-content .col:nth-child(1) {
    flex-basis: 0%;
  }

  .second-content .col:nth-child(2) {
    flex-basis: 100%;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .content .col {
    flex-basis: calc(100%);
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .second-content .col:nth-child(1) {
    flex-basis: 33%;
    margin: 0px 10px 0px 10px;
  }

  .second-content .col:nth-child(2) {
    flex-basis: 66%;
    margin: 0px 20px 0px 10px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .content .col {
    flex-basis: 375px;
    flex-grow: 1;
    margin-left: 20px;
    margin-right: 20px;
  }

  .space-holder {
    margin-bottom: 130px;
  }

  .second-content .col:nth-child(1) {
    flex-basis: 33%;
    margin: 0px 10px 0px 10px;
  }

  .second-content .col:nth-child(2) {
    flex-basis: 66%;
    margin: 0px 20px 0px 10px;
  }
}
</style>
